



























































































































































































































































































































import { Component, Emit, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'
import { IAtomSelectItem } from '@/components/atoms/AtomSelect/AtomSelect.type'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import {
  BookMaxlength,
  CollectionStatus,
  MarkMaxlength,
  NdcMask,
  NdcMaxlength,
  SubMaxlength
} from '@/types'

export interface InputBasicSearchCollectionItem {
  [key: string]: any
  collectionTypes: {
    input: string
    errorMessage: string
  }
  shelfTypes: {
    input: string
    errorMessage: string
  }
  callNumberMark: {
    input: string
    errorMessage: string
  }
  callNumberNdc: {
    input: string
    errorMessage: string
  }
  callNumberBook: {
    input: string
    errorMessage: string
  }
  callNumberSub: {
    input: string
    errorMessage: string
  }
  traderCodes: {
    input: string
    errorMessage: string
  }
  donorCodes: {
    input: string
    errorMessage: string
  }
  collectionStatus: {
    input: string
    errorMessage: string
    collectionStatusRemove: boolean
  }
  holdingBranchCodes: {
    input: string
    errorMessage: string
  }
  orderStatus: {
    input: string
    errorMessage: string
  }
  orderBranchCodes: {
    input: string
    errorMessage: string
  }
  acceptDateFrom: {
    input: string
    errorMessage: string
  }
  acceptDateTo: {
    input: string
    errorMessage: string
  }
  handlingTypes: {
    input: string
    errorMessage: string
  }
  lendTotal: {
    input: string
    errorMessage: string
  }
  lendTotalFlag: {
    input: string
  }
  lastLendDate: {
    input: string
    errorMessage: string
  }
  lastLendDateFlag: {
    input: string
  }
}

export const defaultInputBasicSearchCollectionItem = (): InputBasicSearchCollectionItem => ({
  collectionTypes: {
    input: '',
    errorMessage: ''
  },
  shelfTypes: {
    input: '',
    errorMessage: ''
  },
  callNumberMark: {
    input: '',
    errorMessage: ''
  },
  callNumberNdc: {
    input: '',
    errorMessage: ''
  },
  callNumberBook: {
    input: '',
    errorMessage: ''
  },
  callNumberSub: {
    input: '',
    errorMessage: ''
  },
  traderCodes: {
    input: '',
    errorMessage: ''
  },
  donorCodes: {
    input: '',
    errorMessage: ''
  },
  collectionStatus: {
    input: '',
    errorMessage: '',
    collectionStatusRemove: false
  },
  holdingBranchCodes: {
    input: '',
    errorMessage: ''
  },
  orderStatus: {
    input: '',
    errorMessage: ''
  },
  orderBranchCodes: {
    input: '',
    errorMessage: ''
  },
  acceptDateFrom: {
    input: '',
    errorMessage: ''
  },
  acceptDateTo: {
    input: '',
    errorMessage: ''
  },
  handlingTypes: {
    input: '',
    errorMessage: ''
  },
  lendTotal: {
    input: '',
    errorMessage: ''
  },
  lendTotalFlag: {
    input: '1'
  },
  lastLendDate: {
    input: '',
    errorMessage: ''
  },
  lastLendDateFlag: {
    input: '1'
  }
})

@Component({
  components: {
    InputDatePicker,
    InputCodeDonor,
    InputCodeTrader,
    InputCode,
    ButtonToggle
  }
})
export default class BibliographyBasicSearchCollection extends ComponentVue {
  @PropSync('input', {
    type: Object
  })
  inputItem!: InputBasicSearchCollectionItem

  selectActiveValue: string = '0'

  get selectItems(): IAtomSelectItem[] {
    return [
      {
        value: '0',
        text: '業者'
      },
      {
        value: '1',
        text: '寄贈者'
      }
    ]
  }

  @Watch('selectActiveValue')
  onChangeSelectActiveValue(): void {
    if (this.isTrader) {
      this.inputItem.donorCodes = {
        input: '',
        errorMessage: ''
      }
    } else {
      this.inputItem.traderCodes = {
        input: '',
        errorMessage: ''
      }
    }
  }

  get lendTotalMask(): string {
    return '#'.repeat(5)
  }

  get markMaxlength(): string {
    return MarkMaxlength
  }

  get ndcMask(): string {
    return NdcMask
  }

  get ndcMaxlength(): string {
    return NdcMaxlength
  }

  get bookMaxlength(): string {
    return BookMaxlength
  }

  get subMaxlength(): string {
    return SubMaxlength
  }

  get isTrader(): boolean {
    return this.selectActiveValue === '0'
  }

  get collectionStatusDisabledCodes(): string[] {
    if (!this.inputItem.collectionStatus.collectionStatusRemove) {
      return [CollectionStatus.Removed]
    }

    return []
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
